export const DEFAULT_WINDOW_REFRESH_ALERT = 'Si vuelves a cargar o cierras esta pestaña se va a perder tu progreso';
export const RESTART_FROM_ORIGINAL_URL_MESSAGE = 'Por favor accede desde el enlace que se te hizo llegar para volver a empezar.';
export const RESTART_FROM_ORIGINAL_URL_CODE = 990;